// extracted by mini-css-extract-plugin
module.exports = {"newTicketButton":"header-actions_newTicketButton__zz1xT","divider":"header-actions_divider__Kb7LW","actions":"header-actions_actions__Hbo4a"};